import React, { useEffect, useMemo, useState } from "react";
import { CleanFiltersIcon, IconSearch, SearchUser } from "~misc/icons";
import CustomSelect from "~components/Form/components/Select";
import { FormControl } from "@chakra-ui/react";
import { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
registerLocale("ptBR", ptBR);
import "react-datepicker/dist/react-datepicker.css";
import { useTheRouteData } from "../../hooks/useTheRouteData";
import useSelect from "~components/Form/hooks/useSelect";
import CustomSelectDatePicker from "~components/Form/components/CustomSelectDatePicker";
import PropTypes from "prop-types";

const RotaDoDiaFiltroVisitas = ({ filters, setFilters, cleanFilters, type, uniqueLocais }) => {
  const { data } = useTheRouteData();
  const periodo = useSelect("periodo");
  const selectStatus = useSelect("status");
  const selectVisita = useSelect("visita");
  const selectTipoCliente = useSelect("tipoCliente");

  const optionsTipoCliente = [
    { label: "Emissor", value: "EMISSOR" },
    { label: "Recebedor", value: "RECEBEDOR" },
    { label: "Prospect", value: "PROSPECT" },
  ];

  function onChangeStatus(e) {
    selectStatus.upDateValue(e.value);
    selectStatus.upDateDefaultValue(e || "");
    setFilters({ ...filters, status: e.value });
  }
  function onChangeVisita(e) {
    selectVisita.upDateValue(e.value);
    selectVisita.upDateDefaultValue(e || "");
    setFilters({ ...filters, tema: e.value });
  }
  function onChangeTipoCliente(e) {
    selectTipoCliente.upDateValue(e.value);
    selectTipoCliente.upDateDefaultValue(e || "");
    setFilters({ ...filters, tipoCliente: e.value });
  }

  const [inputValue, setInputValue] = useState("");
  const [searchValue, setSearchValue] = useState("");

  useEffect(() => {
    setFilters({ ...filters, search: searchValue });
  }, [searchValue]);

  const optionsStatusVisita = useMemo(() => {
    const seen = new Set();
    return (data || [])
      .filter((item) => {
        const statusCode = item.status.cod;
        if (!seen.has(statusCode)) {
          seen.add(statusCode);
          return true;
        }
        return false;
      })
      .map((item) => ({ label: item.status.text, value: item.status.cod }));
  }, [data]);

  const optionsTiposVisita = useMemo(() => {
    const seen = new Set();
    const result = [];
    for (const item of uniqueLocais || []) {
      const tipoCod = item.localId;
      if (!seen.has(tipoCod)) {
        seen.add(tipoCod);
        result.push({ label: item.local, value: tipoCod });
      }
    }
    return result;
  }, [uniqueLocais]);

  const keyEnter = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      setSearchValue(inputValue);
    }
  };

  return (
    <div className="route-optimization-container" data-testid="rota-dia-filtro-visitas">
      <div className="route-optimization-filter">
        <form action="" className="">
          <div className="grow relative flex items-center" data-testid="search-container">
            <label className="absolute top-[28%] left-[10px] z-10 w-[23px] h-[23px]">
              <SearchUser />
            </label>
            <input
              data-testid="search-input"
              className="input-search w-full py-5 px-10 rounded-lg  border border-solid border-gray-300  placeholder-primaria text-16"
              type="text"
              value={inputValue}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={keyEnter}
              placeholder={"Buscar Cliente por Código Emissor ou Razão Social/Nome"}
            />
            <button
              className="absolute top-50 right-0 p-4 z-2"
              type="button"
              onClick={() => setSearchValue(inputValue)}
              data-testid="search-button"
            >
              <IconSearch />
            </button>
          </div>

          <div className="flex mt-4 gap-x-3" data-testid="filters-container">
            {type === "of" && (
              <FormControl data-testid="status-form-control">
                <CustomSelect
                  data-testid="status-select"
                  className="select-filter focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
                  name="status"
                  label="Status da Visita:"
                  placeholder="Status da visita:"
                  spacingControl={true}
                  options={optionsStatusVisita}
                  onChange={(e) => {
                    onChangeStatus(e);
                  }}
                  {...selectStatus}
                />
              </FormControl>
            )}
            <FormControl data-testid="periodo-form-control">
              <CustomSelectDatePicker
                setFilters={setFilters}
                filters={filters}
                periodo={periodo}
                type={type !== "mapa"}
              />
            </FormControl>
            {type !== "mapa" ? (
              <>
                <FormControl data-testid="local-form-control">
                  <CustomSelect
                    data-testid="local-select"
                    className="select-filter focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
                    name="visita"
                    label="Local da Pesquisa:"
                    placeholder="Local da Pesquisa:"
                    options={optionsTiposVisita}
                    onChange={(e) => {
                      onChangeVisita(e);
                    }}
                    {...selectVisita}
                  />
                </FormControl>
                <FormControl data-testid="tipo-cliente-form-control">
                  <CustomSelect
                    data-testid="tipo-cliente-select"
                    className="select-filter focus:outline-none focus:border-none focus:shadow-none focus-visible:outline-none focus-visible:border-none focus-visible:shadow-none"
                    name="tipoCliente"
                    label="Tipo de Cliente:"
                    placeholder="Tipo de Cliente:"
                    options={optionsTipoCliente}
                    onChange={(e) => {
                      onChangeTipoCliente(e);
                    }}
                    {...selectTipoCliente}
                  />
                </FormControl>
              </>
            ) : (
              <FormControl data-testid="clean-filters-form-control-mapa">
                <div className="flex justify-center align-center w-full h-full">
                  <button
                    data-testid="clean-filters-button-mapa"
                    type="button"
                    className="flex-shrink-0 flex items-center gap-4 ml-auto  mr-6"
                    onClick={() => {
                      cleanFilters(periodo);
                      selectStatus.upDateDefaultValue("");
                      selectStatus.upDateValue("");
                      selectVisita.upDateDefaultValue("");
                      selectVisita.upDateValue("");
                      selectTipoCliente.upDateDefaultValue("");
                      selectTipoCliente.upDateValue("");
                      setInputValue("");
                      setSearchValue("");
                    }}
                  >
                    <span className="font-semibold text-lg">Limpar Filtros</span>
                    <CleanFiltersIcon />
                  </button>
                </div>
              </FormControl>
            )}
          </div>
          {type !== "mapa" && (
            <div data-testid="clean-filters-container">
              <button
                data-testid="clean-filters-button"
                type="button"
                className="flex-shrink-0 flex items-center gap-4 ml-auto  mr-6"
                onClick={() => {
                  cleanFilters(periodo);
                  selectStatus.upDateDefaultValue("");
                  selectStatus.upDateValue("");
                  selectVisita.upDateDefaultValue("");
                  selectVisita.upDateValue("");
                  selectTipoCliente.upDateDefaultValue("");
                  selectTipoCliente.upDateValue("");
                  setInputValue("");
                }}
              >
                <span className="font-semibold text-lg">Limpar Filtros</span>
                <CleanFiltersIcon />
              </button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
};

RotaDoDiaFiltroVisitas.propTypes = {
  filters: PropTypes.object.isRequired,
  setFilters: PropTypes.func.isRequired,
  cleanFilters: PropTypes.func.isRequired,
  type: PropTypes.string,
  uniqueLocais: PropTypes.array,
};

export default RotaDoDiaFiltroVisitas;
